import React, { useState, useEffect } from 'react';
import {



  SafeAreaView,
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  FlatList,
  Dimensions,
  Alert,
  Modal,
  TextInput,
  RefreshControl,
  ActivityIndicator,
  KeyboardAvoidingView,
  Platform,
  Image,
  Switch,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';

// ===== API Configuration =====
const API_BASE_URL = 'https://api.jobeng.ai';

const getCompanyId = async () => {
  try {
    const userData = await AsyncStorage.getItem('currentUser');
    if (userData) {
      const user = JSON.parse(userData);
      return user.company_id || user.companyId || null;
    }
    const companyProfile = await AsyncStorage.getItem('companyProfile');
    if (companyProfile) {
      const company = JSON.parse(companyProfile);
      return company.id || company.company_id || null;
    }
    const bid = await AsyncStorage.getItem('company_id') || await AsyncStorage.getItem('company_id');
    if (bid) return bid;
    return null;
  } catch (e) {
    console.error('Error getting company_id:', e);
    return null;
  }
};

const apiRequest = async (endpoint, options = {}) => {
  try {
    const companyId = await getCompanyId();
    // Split endpoint and query string
    const [path, queryString] = endpoint.split('?');
    // Route: auth/* goes to /api/auth/*, everything else to /api/data/{table}
    let baseUrl;
    if (path.startsWith('auth/')) {
      baseUrl = `${API_BASE_URL}/api/${path}`;
    } else {
      // Convert hyphens to underscores for DB table mapping
      const dbPath = path.replace(/-/g, '_');
      baseUrl = `${API_BASE_URL}/api/data/${dbPath}`;
    }
    const params = new URLSearchParams(queryString || '');
    if (companyId) { params.set('company_id', companyId); params.set('company_id', companyId); }
    const separator = params.toString() ? '?' : '';
    const url = `${baseUrl}${separator}${params.toString()}`;

    const token = await AsyncStorage.getItem('auth_token') || await AsyncStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json', 'X-API-Key': '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef' };
    if (token) headers.Authorization = 'Bearer ' + token;
    const fetchOpts = { headers, ...options };
    if (options.body) fetchOpts.body = JSON.stringify(options.body);
    const response = await fetch(url, fetchOpts);

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};
// ===== End API Configuration =====


const { width } = Dimensions.get('window');

const TestApplicantsScreen = ({ navigation, route }) => {
  
  const jobId = route?.params?.jobId || route?.params?.job_id || null;
  const jobTitle = route?.params?.jobTitle || '';
  const [companyLogo, setCompanyLogo] = useState(route?.params?.companyLogo || null);
  const [companyName, setCompanyName] = useState(route?.params?.companyName || '');
const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: 'All',
    testType: 'All',
    score: 'All',
    position: 'All'
  });

  const [testData, setTestData] = useState({
    overview: {
      totalApplicants: 234,
      testsAssigned: 189,
      testsCompleted: 156,
      testsPending: 33,
      testsExpired: 12,
      averageScore: 76.8,
      passRate: 68.5,
      completionRate: 82.5,
      averageTime: 45,
      topPerformers: 23,
      needsReview: 18
    },
    applicants: [],
    tests: [],
    results: [],
    analytics: {
      testPerformance: [
        { test: 'JavaScript', avgScore: 78.5, completion: 85.2 },
        { test: 'React', avgScore: 74.3, completion: 79.8 },
        { test: 'Python', avgScore: 81.2, completion: 88.1 },
        { test: 'SQL', avgScore: 69.7, completion: 76.4 },
        { test: 'Problem Solving', avgScore: 72.9, completion: 82.3 }
      ],
      scoreDistribution: [
        { range: '90-100', count: 23, percentage: 14.7 },
        { range: '80-89', count: 45, percentage: 28.8 },
        { range: '70-79', count: 52, percentage: 33.3 },
        { range: '60-69', count: 28, percentage: 17.9 },
        { range: '50-59', count: 8, percentage: 5.1 }
      ],
      testTrends: [
        { month: 'Jan', assigned: 45, completed: 38 },
        { month: 'Feb', assigned: 52, completed: 44 },
        { month: 'Mar', assigned: 38, completed: 32 },
        { month: 'Apr', assigned: 61, completed: 51 },
        { month: 'May', assigned: 48, completed: 42 },
        { month: 'Jun', assigned: 55, completed: 49 }
      ],
      positionPerformance: [
        { position: 'Frontend Dev', avgScore: 79.2, count: 45 },
        { position: 'Backend Dev', avgScore: 82.1, count: 38 },
        { position: 'Full Stack', avgScore: 76.8, count: 52 },
        { position: 'Data Scientist', avgScore: 84.3, count: 21 }
      ]
    },
    notifications: [
      {
        id: 1,
        type: 'urgent',
        title: 'Tests Expiring Soon',
        message: '8 tests will expire in 24 hours',
        timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
        read: false
      },
      {
        id: 2,
        type: 'info',
        title: 'New Test Results',
        message: '15 new test results available for review',
        timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000),
        read: false
      },
      {
        id: 3,
        type: 'success',
        title: 'High Scorer Alert',
        message: 'Sarah Johnson scored 95% on JavaScript test',
        timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000),
        read: true
      }
    ]
  });

  // ── Create Test State ──
  const [testForm, setTestForm] = useState({ title: '', description: '', category: 'Technical', duration: '60', passing_score: '70', max_attempts: '3', shuffle_questions: true, show_results: true, instructions: '' });
  const [qForm, setQForm] = useState({ question: '', type: 'multiple_choice', options: ['', '', '', ''], correct_answer: '', difficulty: 'medium', category: 'Technical', points: '10', explanation: '' });
  const [questionBank, setQuestionBank] = useState([]);
  const CATEGORIES = ['Technical', 'Behavioral', 'Aptitude', 'Language', 'Personality', 'Coding', 'Design', 'Leadership'];
  const Q_TYPES = ['multiple_choice', 'true_false', 'short_answer', 'coding', 'essay'];
  const DIFFICULTY = ['easy', 'medium', 'hard', 'expert'];
  const TEMPLATES = [
    { id: 'tech_sr', name: 'Senior Developer', category: 'Technical', questions: 15, duration: 60, desc: 'Full-stack, system design, algorithms' },
    { id: 'tech_jr', name: 'Junior Developer', category: 'Technical', questions: 10, duration: 30, desc: 'Basics, data structures, OOP' },
    { id: 'behav', name: 'Behavioral Assessment', category: 'Behavioral', questions: 12, duration: 25, desc: 'STAR method, teamwork, leadership' },
    { id: 'apt', name: 'Aptitude Test', category: 'Aptitude', questions: 20, duration: 30, desc: 'Logic, math, verbal reasoning' },
    { id: 'lang_en', name: 'English Proficiency', category: 'Language', questions: 25, duration: 20, desc: 'Grammar, comprehension, writing' },
    { id: 'personality', name: 'Personality Profile', category: 'Personality', questions: 30, duration: 15, desc: 'DISC, Big Five traits' },
    { id: 'coding_react', name: 'React/RN Challenge', category: 'Coding', questions: 5, duration: 90, desc: 'Components, hooks, state management' },
    { id: 'coding_py', name: 'Python Challenge', category: 'Coding', questions: 5, duration: 90, desc: 'Algorithms, Django/Flask' },
    { id: 'design', name: 'UX/UI Assessment', category: 'Design', questions: 8, duration: 45, desc: 'Wireframing, user flows, accessibility' },
    { id: 'lead', name: 'Leadership Assessment', category: 'Leadership', questions: 15, duration: 30, desc: 'Decision making, delegation, vision' },
  ];
  const getDiffColor = d => ({ easy: '#10B981', medium: '#F59E0B', hard: '#EF4444', expert: '#8B5CF6' })[d] || '#6B7280';
  const getTypeIcon = t => ({ multiple_choice: 'format-list-bulleted', true_false: 'check-circle', short_answer: 'text-short', coding: 'code-tags', essay: 'text-long' })[t] || 'help-circle';

  const [newTestAssignment, setNewTestAssignment] = useState({
    testType: 'JavaScript',
    duration: '60',
    deadline: '',
    instructions: '',
    passingScore: '70',
    allowRetake: false,
    randomizeQuestions: true
  });

  const statuses = ['All', 'Not Assigned', 'Assigned', 'In Progress', 'Completed', 'Expired', 'Failed'];
  const testTypes = ['All', 'JavaScript', 'React', 'Python', 'SQL', 'Problem Solving', 'System Design', 'Algorithms'];
  const scoreRanges = ['All', '90-100', '80-89', 'All', '70-79', '60-69', '50-59', 'Below 50'];
  const positions = ['All', 'Frontend Developer', 'Backend Developer', 'Full Stack Developer', 'Data Scientist', 'DevOps Engineer'];

  const tabs = [
    { id: 'overview', title: 'Overview', icon: 'view-dashboard' },
    { id: 'applicants', title: 'Applicants', icon: 'account-group' },
    { id: 'tests', title: 'Tests', icon: 'clipboard-text' },
    { id: 'results', title: 'Results', icon: 'chart-line' },
    { id: 'analytics', title: 'Analytics', icon: 'chart-donut' },
    { id: 'create_test', title: 'Create Test', icon: 'plus-circle' },
    { id: 'questions', title: 'Questions', icon: 'help-circle-outline' },
    { id: 'templates', title: 'Templates', icon: 'file-document-multiple' },
    { id: 'assign_test', title: 'Assign', icon: 'account-arrow-right' },
  ];

    // Company logo (same as EditSupplierScreen)
  useFocusEffect(React.useCallback(() => { loadCompanyLogo(); }, []));
  const loadCompanyLogo = async () => {
    try {
      const cachedProfile = await AsyncStorage.getItem('company_profile');
      if (cachedProfile) {
        const profile = JSON.parse(cachedProfile);
        setCompanyLogo(profile.logo || null);
        if (profile.name || profile.company_name) setCompanyName(profile.name || profile.company_name);
      }
    } catch (e) { console.warn('Logo load error:', e.message); }
  };

  useEffect(() => { (async () => { try { const q = await AsyncStorage.getItem('jobeng_questions'); if (q) setQuestionBank(JSON.parse(q)); } catch {} })(); }, []);

useEffect(() => {
    loadTestData();
    const interval = setInterval(loadTestData, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  const loadTestData = async () => {
    if (!refreshing) setLoading(true);
    
    try {
      // Try API first, then fall back to cache
      let storedData = null;
      try {
        const response = await apiRequest('test-applicants');
        if (response.success && response.data && (Array.isArray(response.data) ? response.data.length > 0 : Object.keys(response.data).length > 0)) {
          storedData = JSON.stringify(response.data);
          await AsyncStorage.setItem('testApplicantsData', storedData);
        }
      } catch (apiError) {
        console.warn('API unavailable for test-applicants:', apiError.message);
      }
      // Fallback: fetch from applications table (real candidate data)
      if (!storedData) {
        try {
          const appsResponse = await apiRequest('applications');
          if (appsResponse.success && appsResponse.data && appsResponse.data.length > 0) {
            const applicants = appsResponse.data.map(app => ({
              id: app.id, name: app.candidate_name, email: app.candidate_email,
              position: app.current_title || 'Position', status: ['assessment','video_interview','final_interview'].includes(app.stage) ? 'in_progress' : app.stage === 'hired' || app.stage === 'accepted' ? 'completed' : 'pending',
              testScore: app.ai_score || 0, testAssigned: app.stage === 'assessment',
              testDeadline: null, attempts: 0, applicationDate: app.applied_date,
              stage: app.stage, aiScore: app.ai_score,
            }));
            const mockData = await generateMockTestData();
            mockData.applicants = applicants;
            mockData.overview = { ...mockData.overview, totalApplicants: applicants.length };
            storedData = JSON.stringify(mockData);
            await AsyncStorage.setItem('testApplicantsData', storedData);
          }
        } catch (e2) { console.warn('Applications fallback failed:', e2.message); }
      }
      if (!storedData) {
        storedData = await AsyncStorage.getItem('testApplicantsData');
      }
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setTestData(prev => ({ ...prev, ...parsedData }));
      } else {
        const mockData = await generateMockTestData();
        setTestData(prev => ({ ...prev, ...mockData }));
        await AsyncStorage.setItem('testApplicantsData', JSON.stringify(mockData));
        // Sync mock data to API
        try { await apiRequest('test-applicants', { method: 'POST', body: mockData }); } catch(e) {}
      }
    } catch (error) {
      console.error('Error loading test data:', error);
      Alert.alert('Error', 'Failed to load test data');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const generateMockTestData = async () => {
    const applicants = Array.from({ length: 234 }, (_, index) => ({
      id: index + 1,
      name: `Applicant ${index + 1}`,
      email: `applicant${index + 1}@email.com`,
      phone: `555-${Math.floor(Math.random() * 900) + 100}-${Math.floor(Math.random() * 9000) + 1000}`,
      position: positions[Math.floor(Math.random() * (positions.length - 1)) + 1],
      experience: ['Entry Level', 'Mid Level', 'Senior Level'][Math.floor(Math.random() * 3)],
      status: statuses[Math.floor(Math.random() * (statuses.length - 1)) + 1],
      testAssigned: Math.random() > 0.2,
      testType: testTypes[Math.floor(Math.random() * (testTypes.length - 1)) + 1],
      testScore: Math.random() > 0.3 ? Math.floor(Math.random() * 50) + 50 : null,
      testDuration: Math.random() > 0.3 ? Math.floor(Math.random() * 60) + 30 : null,
      testStarted: Math.random() > 0.4 ? new Date(Date.now() - Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000).toISOString().split('T')[0] : null,
      testCompleted: Math.random() > 0.5 ? new Date(Date.now() - Math.floor(Math.random() * 5) * 24 * 60 * 60 * 1000).toISOString().split('T')[0] : null,
      testDeadline: new Date(Date.now() + Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      attempts: Math.floor(Math.random() * 3) + 1,
      timeSpent: Math.random() > 0.3 ? Math.floor(Math.random() * 90) + 30 : null,
      passingScore: 70,
      passed: null,
      feedback: 'Good performance with room for improvement in specific areas.',
      strengths: ['Problem solving', 'Code quality'],
      weaknesses: ['Time management', 'Edge cases'],
      applicationDate: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1).toISOString().split('T')[0]
    }));

    // Set passed status based on score
    applicants.forEach(applicant => {
      if (applicant.testScore !== null) {
        applicant.passed = applicant.testScore >= applicant.passingScore;
        applicant.status = applicant.passed ? 'Completed' : 'Failed';
      }
    });

    const tests = Array.from({ length: 189 }, (_, index) => ({
      id: index + 1,
      applicantId: Math.floor(Math.random() * 234) + 1,
      type: testTypes[Math.floor(Math.random() * (testTypes.length - 1)) + 1],
      name: `${testTypes[Math.floor(Math.random() * (testTypes.length - 1)) + 1]} Assessment`,
      status: ['Assigned', 'In Progress', 'Completed', 'Expired'][Math.floor(Math.random() * 4)],
      assignedDate: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1).toISOString().split('T')[0],
      deadline: new Date(Date.now() + Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      duration: Math.floor(Math.random() * 60) + 30,
      questions: Math.floor(Math.random() * 20) + 10,
      passingScore: 70,
      allowRetake: Math.random() > 0.5,
      randomizeQuestions: Math.random() > 0.3,
      instructions: 'Complete all questions within the time limit. You can save and resume your progress.',
      createdBy: `HR Manager ${Math.floor(Math.random() * 5) + 1}`,
      difficulty: ['Easy', 'Medium', 'Hard'][Math.floor(Math.random() * 3)]
    }));

    const results = Array.from({ length: 156 }, (_, index) => ({
      id: index + 1,
      applicantId: Math.floor(Math.random() * 234) + 1,
      testId: Math.floor(Math.random() * 189) + 1,
      score: Math.floor(Math.random() * 50) + 50,
      maxScore: 100,
      passed: null,
      timeSpent: Math.floor(Math.random() * 90) + 30,
      questionsAnswered: Math.floor(Math.random() * 20) + 10,
      correctAnswers: Math.floor(Math.random() * 15) + 5,
      completedDate: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1).toISOString().split('T')[0],
      attempt: Math.floor(Math.random() * 3) + 1,
      feedback: 'Strong technical knowledge with good problem-solving approach.',
      detailedResults: {
        sections: [
          { name: 'Syntax & Basics', score: Math.floor(Math.random() * 40) + 60 },
          { name: 'Problem Solving', score: Math.floor(Math.random() * 40) + 60 },
          { name: 'Best Practices', score: Math.floor(Math.random() * 40) + 60 },
          { name: 'Advanced Concepts', score: Math.floor(Math.random() * 40) + 60 }
        ]
      },
      flaggedQuestions: Math.floor(Math.random() * 3),
      reviewNotes: 'Candidate showed strong understanding of core concepts.'
    }));

    // Set passed status based on score
    results.forEach(result => {
      result.passed = result.score >= 70;
    });

    return {
      applicants,
      tests,
      results
    };
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await loadTestData();
  };

  const saveTestData = async (updatedData) => {
    try {
      // Save via API and cache
      try { await apiRequest('test-applicants', { method: 'PUT', body: updatedData }); } catch(e) { console.warn('API save failed:', e.message); }
      await AsyncStorage.setItem('testApplicantsData', JSON.stringify(updatedData));
      setTestData(prev => ({ ...prev, ...updatedData }));
    } catch (error) {
      console.error('Error saving test data:', error);
      Alert.alert('Error', 'Failed to save test data');
    }
  };

  const assignTest = async () => {
    if (!newTestAssignment.testType || !newTestAssignment.duration) {
      Alert.alert('Error', 'Please fill in all required fields');
      return;
    }

    try {
      const selectedApplicantsList = selectedApplicants.length > 0 ? selectedApplicants : [selectedApplicant?.id];
      
      const newTests = selectedApplicantsList.map(applicantId => ({
        id: testData.tests.length + Math.random(),
        applicantId,
        type: newTestAssignment.testType,
        name: `${newTestAssignment.testType} Assessment`,
        status: 'Assigned',
        assignedDate: new Date().toISOString().split('T')[0],
        deadline: newTestAssignment.deadline || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        duration: parseInt(newTestAssignment.duration),
        passingScore: parseInt(newTestAssignment.passingScore),
        allowRetake: newTestAssignment.allowRetake,
        randomizeQuestions: newTestAssignment.randomizeQuestions,
        instructions: newTestAssignment.instructions || 'Complete all questions within the time limit.',
        createdBy: 'HR Manager',
        difficulty: 'Medium'
      }));

      const updatedApplicants = testData.applicants.map(applicant =>
        selectedApplicantsList.includes(applicant.id) 
          ? { ...applicant, testAssigned: true, status: 'Assigned', testType: newTestAssignment.testType }
          : applicant
      );

      const updatedData = {
        tests: [...testData.tests, ...newTests],
        applicants: updatedApplicants,
        overview: {
          ...testData.overview,
          testsAssigned: testData.overview.testsAssigned + selectedApplicantsList.length
        }
      };

      await saveTestData(updatedData);
      resetNewTestAssignment();
      setSelectedApplicants([]);
      setShowModal(false);
      Alert.alert('Success', `Test assigned to ${selectedApplicantsList.length} applicant(s)`);
    } catch (error) {
      console.error('Error assigning test:', error);
      Alert.alert('Error', 'Failed to assign test');
    }
  };

  const resetNewTestAssignment = () => {
    setNewTestAssignment({
      testType: 'JavaScript',
      duration: '60',
      deadline: '',
      instructions: '',
      passingScore: '70',
      allowRetake: false,
      randomizeQuestions: true
    });
  };

  const getFilteredApplicants = () => {
    return testData.applicants.filter(applicant => {
      const matchesSearch = String(applicant.name ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                           String(applicant.email ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                           String(applicant.position ?? '').toLowerCase().includes(searchQuery.toLowerCase());
      
      const matchesStatus = filters.status === 'All' || applicant.status === filters.status;
      const matchesTestType = filters.testType === 'All' || applicant.testType === filters.testType;
      const matchesPosition = filters.position === 'All' || applicant.position === filters.position;
      const matchesScore = filters.score === 'All' || 
        (filters.score === '90-100' && applicant.testScore >= 90) ||
        (filters.score === '80-89' && applicant.testScore >= 80 && applicant.testScore < 90) ||
        (filters.score === '70-79' && applicant.testScore >= 70 && applicant.testScore < 80) ||
        (filters.score === '60-69' && applicant.testScore >= 60 && applicant.testScore < 70) ||
        (filters.score === '50-59' && applicant.testScore >= 50 && applicant.testScore < 60) ||
        (filters.score === 'Below 50' && applicant.testScore < 50);
      
      return matchesSearch && matchesStatus && matchesTestType && matchesPosition && matchesScore;
    });
  };

  const renderStatCard = (title, value, icon, color, subtitle = null, trend = null, onPress = null) => (
    <TouchableOpacity
      style={[styles.statCard, { borderLeftColor: color }]}
      onPress={onPress}
      disabled={!onPress}
    >
      <View style={styles.statContent}>
        <View style={styles.statHeader}>
          <Text style={styles.statValue}>{value}</Text>
          {trend && (
            <View style={[styles.trendIndicator, { backgroundColor: trend > 0 ? '#10b981' : '#dc2626' }]}>
              <MaterialCommunityIcons 
                name={trend > 0 ? "trending-up" : "trending-down"} 
                size={12} 
                color="#fff" 
              />
              <Text style={styles.trendText}>{Math.abs(trend)}%</Text>
            </View>
          )}
        </View>
        <Text style={styles.statTitle}>{title}</Text>
        {subtitle && <Text style={styles.statSubtitle}>{subtitle}</Text>}
      </View>
      <MaterialCommunityIcons name={icon} size={32} color={color} />
    </TouchableOpacity>
  );

  const renderApplicant = ({ item }) => (
    <TouchableOpacity
      style={[
        styles.applicantCard,
        selectedApplicants.includes(item.id) && styles.selectedCard
      ]}
      onPress={() => {
        setSelectedApplicant(item);
        setModalType('applicant_details');
        setShowModal(true);
      }}
      onLongPress={() => {
        if (selectedApplicants.includes(item.id)) {
          setSelectedApplicants(prev => prev.filter(id => id !== item.id));
        } else {
          setSelectedApplicants(prev => [...prev, item.id]);
        }
      }}
    >
      <View style={styles.applicantHeader}>
        <View style={styles.applicantInfo}>
          <Text style={styles.applicantName}>{item.name}</Text>
          <Text style={styles.applicantPosition}>{item.position}</Text>
          <Text style={styles.applicantEmail}>{item.email}</Text>
          <Text style={styles.applicantExperience}>{item.experience}</Text>
        </View>
        <View style={styles.applicantStatus}>
          <View style={[
            styles.statusBadge,
            { backgroundColor: 
              item.status === 'Completed' ? '#10b981' : 
              item.status === 'In Progress' ? '#06b6d4' :
              item.status === 'Assigned' ? '#8b5cf6' :
              item.status === 'Failed' ? '#dc2626' :
              item.status === 'Expired' ? '#f59e0b' : '#64748b'
            }
          ]}>
            <Text style={styles.statusText}>{item.status}</Text>
          </View>
          {selectedApplicants.includes(item.id) && (
            <MaterialCommunityIcons name="check-circle" size={20} color="#10b981" />
          )}
        </View>
      </View>
      
      <View style={styles.applicantDetails}>
        <View style={styles.applicantDetailItem}>
          <Text style={styles.applicantDetailLabel}>Test Type:</Text>
          <Text style={styles.applicantDetailValue}>{item.testType || 'Not Assigned'}</Text>
        </View>
        <View style={styles.applicantDetailItem}>
          <Text style={styles.applicantDetailLabel}>Score:</Text>
          <Text style={[
            styles.applicantDetailValue,
            { color: 
              item.testScore >= 90 ? '#10b981' :
              item.testScore >= 70 ? '#f59e0b' :
              item.testScore ? '#dc2626' : '#64748b'
            }
          ]}>
            <Text>{item.testScore ? `${item.testScore}/100` : 'Not Taken'}</Text>
          </Text>
        </View>
        <View style={styles.applicantDetailItem}>
          <Text style={styles.applicantDetailLabel}>Deadline:</Text>
          <Text style={styles.applicantDetailValue}>{item.testDeadline || 'Not Set'}</Text>
        </View>
        <View style={styles.applicantDetailItem}>
          <Text style={styles.applicantDetailLabel}>Attempts:</Text>
          <Text style={styles.applicantDetailValue}>{item.attempts || 0}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );

  const renderAnalyticsChart = (title, data, type = 'bar') => (
    <View style={styles.chartContainer}>
      <Text style={styles.chartTitle}>{title}</Text>
      <View style={styles.chartContent}>
        {type === 'bar' && data.map((item, index) => (
          <View key={index} style={styles.barChartItem}>
            <View style={styles.barChartBar}>
              <View 
                style={[
                  styles.barChartFill, 
                  { 
                    height: `${(item.avgScore || item.count || item.assigned || item.completion || 0) / (type === 'score' ? 100 : type === 'completion' ? 100 : Math.max(...data.map(d => d.avgScore || d.count || d.assigned || d.completion))) * 100}%`,
                    backgroundColor: '#0e4e96'
                  }
                ]} 
              />
            </View>
            <Text style={styles.barChartLabel}>{item.test || item.range || item.month || item.position}</Text>
            <Text style={styles.barChartValue}>
              {item.avgScore ? `${item.avgScore}%` : item.count || item.assigned || `${item.completion}%`}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );

  const renderOverviewTab = () => (
    <ScrollView 
      style={styles.tabContent}
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
    >
      {/* Key Metrics */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Test Metrics</Text>
        <View style={styles.statsGrid}>
          {renderStatCard(
            'Total Applicants',
            testData.overview.totalApplicants,
            'account-group',
            '#0e4e96',
            'All applicants',
            5.2,
            () => setActiveTab('applicants')
          )}
          {renderStatCard(
            'Tests Assigned',
            testData.overview.testsAssigned,
            'clipboard-plus',
            '#8b5cf6',
            'Active assignments',
            12.8,
            () => setActiveTab('tests')
          )}
          {renderStatCard(
            'Tests Completed',
            testData.overview.testsCompleted,
            'check-circle',
            '#10b981',
            'Finished tests',
            8.7,
            () => setActiveTab('results')
          )}
          {renderStatCard(
            'Tests Pending',
            testData.overview.testsPending,
            'clock-outline',
            '#f59e0b',
            'In progress',
            -3.2
          )}
          {renderStatCard(
            'Average Score',
            `${testData.overview.averageScore}%`,
            'star',
            '#06b6d4',
            'Overall performance',
            2.1
          )}
          {renderStatCard(
            'Pass Rate',
            `${testData.overview.passRate}%`,
            'trophy',
            '#10b981',
            'Success rate',
            4.5
          )}
        </View>
      </View>

      {/* Quick Actions */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Quick Actions</Text>
        <View style={styles.quickActionsGrid}>
          <TouchableOpacity
            style={styles.quickAction}
            onPress={() => {
              setModalType('assign_test');
              setShowModal(true);
            }}
          >
            <MaterialCommunityIcons name="clipboard-plus" size={24} color="#8b5cf6" />
            <Text style={styles.quickActionText}>Assign Test</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.quickAction}
            onPress={() => setActiveTab('results')}
          >
            <MaterialCommunityIcons name="chart-line" size={24} color="#10b981" />
            <Text style={styles.quickActionText}>View Results</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.quickAction}
            onPress={() => setActiveTab('applicants')}
          >
            <MaterialCommunityIcons name="account-search" size={24} color="#06b6d4" />
            <Text style={styles.quickActionText}>Review Applicants</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.quickAction}
            onPress={() => Alert.alert('Bulk Actions', 'Bulk test assignment functionality would be implemented here')}
          >
            <MaterialCommunityIcons name="select-multiple" size={24} color="#f59e0b" />
            <Text style={styles.quickActionText}>Bulk Actions</Text>
          </TouchableOpacity>
        </View>
      </View>

      {/* Test Performance */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Test Performance by Type</Text>
        {renderAnalyticsChart('Average Scores by Test Type', testData.analytics.testPerformance, 'score')}
      </View>

      {/* Performance Metrics */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Performance Metrics</Text>
        <View style={styles.additionalMetrics}>
          <View style={styles.metricItem}>
            <Text style={styles.metricLabel}>Completion Rate</Text>
            <Text style={styles.metricValue}>{testData.overview.completionRate}%</Text>
          </View>
          <View style={styles.metricItem}>
            <Text style={styles.metricLabel}>Average Time</Text>
            <Text style={styles.metricValue}>{testData.overview.averageTime} min</Text>
          </View>
          <View style={styles.metricItem}>
            <Text style={styles.metricLabel}>Top Performers</Text>
            <Text style={styles.metricValue}>{testData.overview.topPerformers}</Text>
          </View>
          <View style={styles.metricItem}>
            <Text style={styles.metricLabel}>Needs Review</Text>
            <Text style={styles.metricValue}>{testData.overview.needsReview}</Text>
          </View>
        </View>
      </View>
    </ScrollView>
  );

  const renderApplicantsTab = () => {
    const filteredApplicants = getFilteredApplicants();
    
    return (
      <View style={styles.tabContentFull}>
        {/* Search and Filters */}
        <View style={styles.searchSection}>
          <View style={styles.searchContainer}>
            <MaterialCommunityIcons name="magnify" size={20} color="#64748b" />
            <TextInput
              style={styles.searchInput}
              placeholder="Search applicants..."
              value={searchQuery}
              onChangeText={setSearchQuery}
            />
          </View>
          <TouchableOpacity
            style={styles.filterButton}
            onPress={() => setShowFilters(!showFilters)}
          >
            <MaterialCommunityIcons name="filter" size={20} color="#0e4e96" />
          </TouchableOpacity>
        </View>

        {/* Bulk Actions */}
        {selectedApplicants.length > 0 && (
          <View style={styles.bulkActionsContainer}>
            <Text style={styles.bulkActionsText}>{selectedApplicants.length} selected</Text>
            <View style={styles.bulkActions}>
              <TouchableOpacity
                style={[styles.bulkActionButton, { backgroundColor: '#8b5cf6' }]}
                onPress={() => {
                  setModalType('assign_test');
                  setShowModal(true);
                }}
              >
                <Text style={styles.bulkActionText}>Assign Test</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.bulkActionButton, { backgroundColor: '#64748b' }]}
                onPress={() => setSelectedApplicants([])}
              >
                <Text style={styles.bulkActionText}>Clear</Text>
              </TouchableOpacity>
            </View>
          </View>
        )}

        {/* Applicant Stats */}
        <View style={styles.itemStats}>
          <Text style={styles.itemStatsText}>
            Showing {filteredApplicants.length} of {testData.applicants.length} applicants
          </Text>
        </View>
        
        {/* Applicant List */}
        <FlatList
          data={filteredApplicants}
          renderItem={renderApplicant}
          keyExtractor={(item) => item.id.toString()}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.itemsList}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
          ListEmptyComponent={
            <View style={styles.emptyContainer}>
              <MaterialCommunityIcons name="clipboard-text" size={64} color="#94a3b8" />
              <Text style={styles.emptyText}>No applicants found</Text>
              <Text style={styles.emptySubtext}>Try adjusting your search or filters</Text>
            </View>
          }
        />
      </View>
    );
  };

  const renderTestsTab = () => (
    <ScrollView 
      style={styles.tabContent}
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
    >
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Test Overview</Text>
        <View style={styles.statsGrid}>
          {renderStatCard(
            'Total Tests',
            testData.tests.length,
            'clipboard-text',
            '#0e4e96',
            'All tests'
          )}
          {renderStatCard(
            'Active Tests',
            testData.tests.filter(t => t.status === 'Assigned' || t.status === 'In Progress').length,
            'play-circle',
            '#8b5cf6',
            'In progress'
          )}
          {renderStatCard(
            'Completed',
            testData.tests.filter(t => t.status === 'Completed').length,
            'check-circle',
            '#10b981',
            'Finished'
          )}
          {renderStatCard(
            'Expired',
            testData.tests.filter(t => t.status === 'Expired').length,
            'clock-alert',
            '#dc2626',
            'Past deadline'
          )}
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Test Completion Trends</Text>
        {renderAnalyticsChart('Monthly Test Trends', testData.analytics.testTrends, 'assigned')}
      </View>
    </ScrollView>
  );

  const renderResultsTab = () => (
    <ScrollView 
      style={styles.tabContent}
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
    >
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Results Overview</Text>
        <View style={styles.statsGrid}>
          {renderStatCard(
            'Total Results',
            testData.results.length,
            'chart-line',
            '#0e4e96',
            'All results'
          )}
          {renderStatCard(
            'Passed',
            testData.results.filter(r => r.passed).length,
            'check-circle',
            '#10b981',
            'Above passing score'
          )}
          {renderStatCard(
            'Failed',
            testData.results.filter(r => !r.passed).length,
            'close-circle',
            '#dc2626',
            'Below passing score'
          )}
          {renderStatCard(
            'Average Score',
            `${Math.round(testData.results.reduce((sum, r) => sum + r.score, 0) / testData.results.length)}%`,
            'star',
            '#f59e0b',
            'Overall average'
          )}
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Score Distribution</Text>
        {renderAnalyticsChart('Score Distribution', testData.analytics.scoreDistribution)}
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Performance by Position</Text>
        {renderAnalyticsChart('Average Score by Position', testData.analytics.positionPerformance, 'score')}
      </View>
    </ScrollView>
  );

  const renderAnalyticsTab = () => (
    <ScrollView 
      style={styles.tabContent}
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
    >
      {/* Test Performance */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Test Performance by Type</Text>
        {renderAnalyticsChart('Average Scores and Completion Rates', testData.analytics.testPerformance, 'score')}
      </View>

      {/* Score Distribution */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Score Distribution</Text>
        {renderAnalyticsChart('Score Range Distribution', testData.analytics.scoreDistribution)}
      </View>

      {/* Test Trends */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Test Assignment Trends</Text>
        {renderAnalyticsChart('Monthly Test Assignment and Completion', testData.analytics.testTrends, 'assigned')}
      </View>

      {/* Position Performance */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Performance by Position</Text>
        {renderAnalyticsChart('Average Performance by Position', testData.analytics.positionPerformance, 'score')}
      </View>
    </ScrollView>
  );

  const renderTabContent = () => {
    if (loading) {
      return (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading test data...</Text>
        </View>
      );
    }

    // ── Create Test CRUD ──
    const handleCreateTest = async () => {
      if (!testForm.title) { Alert.alert('Error', 'Title required'); return; }
      const payload = { ...testForm, duration: parseInt(testForm.duration) || 60, passing_score: parseInt(testForm.passing_score) || 70, max_attempts: parseInt(testForm.max_attempts) || 3, status: 'draft', question_count: 0, created_at: new Date().toISOString() };
      try { const r = await apiRequest('test-suites', { method: 'POST', body: payload }); if (r?.data?.id) payload.id = r.data.id; else payload.id = 'test_' + Date.now(); } catch { payload.id = 'test_' + Date.now(); }
      setTestData(prev => ({ ...prev, tests: [payload, ...prev.tests] }));
      setTestForm({ title: '', description: '', category: 'Technical', duration: '60', passing_score: '70', max_attempts: '3', shuffle_questions: true, show_results: true, instructions: '' });
      setActiveTab('tests'); Alert.alert('Created', 'Test created successfully');
    };
    const handleAddQuestion = async () => {
      if (!qForm.question) { Alert.alert('Error', 'Question text required'); return; }
      const payload = { ...qForm, points: parseInt(qForm.points) || 10, options: qForm.type === 'multiple_choice' ? qForm.options.filter(o => o.trim()) : [], created_at: new Date().toISOString() };
      try { const r = await apiRequest('test-questions', { method: 'POST', body: payload }); if (r?.data?.id) payload.id = r.data.id; else payload.id = 'q_' + Date.now(); } catch { payload.id = 'q_' + Date.now(); }
      setQuestionBank(prev => [payload, ...prev]);
      setQForm({ question: '', type: 'multiple_choice', options: ['', '', '', ''], correct_answer: '', difficulty: 'medium', category: 'Technical', points: '10', explanation: '' });
      Alert.alert('Added', 'Question added to bank');
    };
    const handleDeleteQuestion = q => { Alert.alert('Delete', 'Remove this question?', [{ text: 'Cancel' }, { text: 'Delete', style: 'destructive', onPress: async () => { try { await apiRequest('test-questions/' + q.id, { method: 'DELETE' }); } catch {} setQuestionBank(prev => prev.filter(x => x.id !== q.id)); } }]); };

    switch (activeTab) {
      case 'overview':
        return renderOverviewTab();
      case 'applicants':
        return renderApplicantsTab();
      case 'tests':
        return renderTestsTab();
      case 'results':
        return renderResultsTab();
      case 'analytics':
        return renderAnalyticsTab();
      case 'create_test':
        return renderCreateTestTab();
      case 'questions':
        return renderQuestionsTab();
      case 'templates':
        return renderTemplatesTab();
      case 'assign_test':
        return renderAssignTab();
      default:
        return renderOverviewTab();
    }
  };


  // ═══════ CREATE TEST TAB ═══════
  const renderCreateTestTab = () => (
    <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : 'height'} style={{ flex: 1 }}>
      <ScrollView style={{ padding: 16 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}>
        <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Create New Assessment Test</Text>
        {[['Test Title *','title','e.g. Senior Developer Assessment'],['Description','description','What this test evaluates...'],['Duration (mins)','duration','60'],['Passing Score (%)','passing_score','70'],['Max Attempts','max_attempts','3'],['Instructions','instructions','Read each question carefully...']].map(([l,k,ph]) => (
          <View key={k} style={{ marginBottom: 14 }}><Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 5 }}>{l}</Text>
            <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 11, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB', ...(k === 'description' || k === 'instructions' ? { height: 80, textAlignVertical: 'top' } : {}) }}
              placeholder={ph} placeholderTextColor="#9CA3AF" value={testForm[k]}
              onChangeText={v => setTestForm(p => ({ ...p, [k]: v }))} multiline={k === 'description' || k === 'instructions'}
              keyboardType={['duration','passing_score','max_attempts'].includes(k) ? 'numeric' : 'default'} /></View>))}
        <Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 8 }}>Category</Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
          {CATEGORIES.map(cat => (<TouchableOpacity key={cat} style={{ paddingHorizontal: 14, paddingVertical: 7, borderRadius: 16, backgroundColor: testForm.category === cat ? '#0e4e96' : '#F1F5F9' }}
            onPress={() => setTestForm(p => ({ ...p, category: cat }))}><Text style={{ color: testForm.category === cat ? '#FFF' : '#6B7280', fontWeight: '600', fontSize: 12 }}>{cat}</Text></TouchableOpacity>))}</View>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 12, borderTopWidth: 1, borderTopColor: '#F3F4F6' }}>
          <Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937' }}>Shuffle Questions</Text>
          <Switch value={testForm.shuffle_questions} onValueChange={v => setTestForm(p => ({ ...p, shuffle_questions: v }))} trackColor={{ true: '#0e4e96' }} /></View>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 12, borderTopWidth: 1, borderTopColor: '#F3F4F6' }}>
          <Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937' }}>Show Results to Applicant</Text>
          <Switch value={testForm.show_results} onValueChange={v => setTestForm(p => ({ ...p, show_results: v }))} trackColor={{ true: '#0e4e96' }} /></View>
        <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0e4e96', borderRadius: 10, padding: 14, marginTop: 12 }} onPress={handleCreateTest}>
          <MaterialCommunityIcons name="check-circle" size={20} color="#FFF" /><Text style={{ color: '#FFF', fontWeight: '700', fontSize: 16, marginLeft: 8 }}>Create Test</Text></TouchableOpacity>
        <View style={{ height: 40 }} />
      </ScrollView>
    </KeyboardAvoidingView>
  );

  // ═══════ QUESTIONS TAB ═══════
  const renderQuestionsTab = () => (
    <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : 'height'} style={{ flex: 1 }}>
      <ScrollView style={{ padding: 16 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}>
        <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Add Question</Text>
        <View style={{ marginBottom: 14 }}><Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 5 }}>Question *</Text>
          <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 11, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB', height: 80, textAlignVertical: 'top' }}
            placeholder="Enter question..." value={qForm.question} onChangeText={v => setQForm(p => ({ ...p, question: v }))} multiline /></View>
        <Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 8 }}>Type</Text>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 12 }}>
          {Q_TYPES.map(t => (<TouchableOpacity key={t} style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: 12, paddingVertical: 7, borderRadius: 16, marginRight: 8, backgroundColor: qForm.type === t ? '#0e4e96' : '#F1F5F9' }}
            onPress={() => setQForm(p => ({ ...p, type: t }))}><MaterialCommunityIcons name={getTypeIcon(t)} size={14} color={qForm.type === t ? '#FFF' : '#6B7280'} />
            <Text style={{ color: qForm.type === t ? '#FFF' : '#6B7280', fontWeight: '600', fontSize: 11, marginLeft: 4 }}>{t.replace(/_/g, ' ')}</Text></TouchableOpacity>))}</ScrollView>
        {qForm.type === 'multiple_choice' && <View style={{ marginBottom: 14 }}><Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 5 }}>Options (tap radio for correct)</Text>
          {qForm.options.map((o, i) => (<View key={i} style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 6 }}>
            <TouchableOpacity onPress={() => setQForm(p => ({ ...p, correct_answer: String(i) }))} style={{ marginRight: 8 }}><MaterialCommunityIcons name={qForm.correct_answer === String(i) ? 'radiobox-marked' : 'radiobox-blank'} size={22} color={qForm.correct_answer === String(i) ? '#0e4e96' : '#D1D5DB'} /></TouchableOpacity>
            <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 11, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB', flex: 1 }} placeholder={'Option ' + (i+1)} value={o}
              onChangeText={v => { const opts = [...qForm.options]; opts[i] = v; setQForm(p => ({ ...p, options: opts })); }} /></View>))}
          <TouchableOpacity onPress={() => setQForm(p => ({ ...p, options: [...p.options, ''] }))}><Text style={{ color: '#0e4e96', fontWeight: '600', fontSize: 13 }}>+ Add Option</Text></TouchableOpacity></View>}
        {qForm.type === 'true_false' && <View style={{ marginBottom: 14 }}><Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 5 }}>Correct Answer</Text>
          <View style={{ flexDirection: 'row', gap: 8 }}>{['True','False'].map(tf => (<TouchableOpacity key={tf} style={{ flex: 1, padding: 12, borderRadius: 8, backgroundColor: qForm.correct_answer === tf ? '#0e4e96' : '#F1F5F9', alignItems: 'center' }}
            onPress={() => setQForm(p => ({ ...p, correct_answer: tf }))}><Text style={{ color: qForm.correct_answer === tf ? '#FFF' : '#6B7280', fontWeight: '600' }}>{tf}</Text></TouchableOpacity>))}</View></View>}
        {(qForm.type === 'short_answer' || qForm.type === 'coding') && <View style={{ marginBottom: 14 }}><Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 5 }}>Expected Answer</Text>
          <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 11, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB' }} placeholder="Keywords or expected answer" value={qForm.correct_answer} onChangeText={v => setQForm(p => ({ ...p, correct_answer: v }))} /></View>}
        <Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 8 }}>Difficulty</Text>
        <View style={{ flexDirection: 'row', gap: 8, marginBottom: 12 }}>{DIFFICULTY.map(d => (<TouchableOpacity key={d} style={{ flex: 1, padding: 8, borderRadius: 8, backgroundColor: qForm.difficulty === d ? getDiffColor(d) : '#F1F5F9', alignItems: 'center' }}
          onPress={() => setQForm(p => ({ ...p, difficulty: d }))}><Text style={{ color: qForm.difficulty === d ? '#FFF' : '#6B7280', fontWeight: '600', fontSize: 12, textTransform: 'capitalize' }}>{d}</Text></TouchableOpacity>))}</View>
        <View style={{ flexDirection: 'row', gap: 8 }}>
          <View style={{ flex: 1, marginBottom: 14 }}><Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 5 }}>Points</Text>
            <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 11, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB' }} value={qForm.points} onChangeText={v => setQForm(p => ({ ...p, points: v }))} keyboardType="numeric" /></View>
          <View style={{ flex: 2, marginBottom: 14 }}><Text style={{ fontSize: 13, fontWeight: '600', color: '#1F2937', marginBottom: 5 }}>Explanation</Text>
            <TextInput style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: 11, fontSize: 14, color: '#1F2937', borderWidth: 1, borderColor: '#E5E7EB' }} placeholder="Why this is correct..." value={qForm.explanation} onChangeText={v => setQForm(p => ({ ...p, explanation: v }))} /></View></View>
        <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0e4e96', borderRadius: 10, padding: 14, marginTop: 4 }} onPress={handleAddQuestion}>
          <MaterialCommunityIcons name="plus-circle" size={20} color="#FFF" /><Text style={{ color: '#FFF', fontWeight: '700', fontSize: 16, marginLeft: 8 }}>Add Question</Text></TouchableOpacity>
        <Text style={{ fontSize: 17, fontWeight: 'bold', color: '#1F2937', marginTop: 20, marginBottom: 12 }}>Question Bank ({questionBank.length})</Text>
        {questionBank.slice(0, 30).map((q, i) => (<View key={q.id || i} style={{ backgroundColor: '#FFF', padding: 12, borderRadius: 8, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 6 }}>
          <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
            <View style={{ width: 24, height: 24, borderRadius: 12, backgroundColor: getDiffColor(q.difficulty), justifyContent: 'center', alignItems: 'center', marginTop: 2 }}><Text style={{ color: '#FFF', fontSize: 10, fontWeight: '600' }}>{(q.difficulty || 'M').charAt(0).toUpperCase()}</Text></View>
            <View style={{ flex: 1, marginLeft: 8 }}><Text style={{ fontSize: 14, fontWeight: '500', color: '#1F2937' }}>{q.question || 'No text'}</Text>
              <Text style={{ fontSize: 11, color: '#9CA3AF', marginTop: 2 }}>{(q.type || '').replace(/_/g, ' ')} \u00B7 {q.points || 10} pts \u00B7 {q.category || 'General'}</Text></View>
            <TouchableOpacity onPress={() => handleDeleteQuestion(q)}><MaterialCommunityIcons name="delete" size={18} color="#EF4444" /></TouchableOpacity></View></View>))}
        <View style={{ height: 40 }} />
      </ScrollView>
    </KeyboardAvoidingView>
  );

  // ═══════ TEMPLATES TAB ═══════
  const renderTemplatesTab = () => (
    <ScrollView style={{ padding: 16 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}>
      <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 6 }}>Test Templates</Text>
      <Text style={{ color: '#6B7280', marginBottom: 16 }}>Tap a template to auto-fill the Create Test form</Text>
      {TEMPLATES.map((tmpl, i) => (<TouchableOpacity key={i} style={{ backgroundColor: '#FFF', marginBottom: 8, padding: 14, borderRadius: 10, borderWidth: 1, borderColor: '#E5E7EB' }}
        onPress={() => { setTestForm({ title: tmpl.name, description: tmpl.desc, category: tmpl.category, duration: String(tmpl.duration), passing_score: '70', max_attempts: '3', shuffle_questions: true, show_results: true, instructions: 'Complete all questions within the time limit.' }); setActiveTab('create_test'); }}>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <View style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: '#0e4e96', justifyContent: 'center', alignItems: 'center', marginRight: 10 }}><MaterialCommunityIcons name="file-document" size={20} color="#FFF" /></View>
          <View style={{ flex: 1 }}><Text style={{ fontSize: 15, fontWeight: '600', color: '#1F2937' }}>{tmpl.name}</Text>
            <Text style={{ fontSize: 12, color: '#6B7280', marginTop: 1 }}>{tmpl.category} \u00B7 {tmpl.questions} questions \u00B7 {tmpl.duration} min</Text>
            <Text style={{ fontSize: 11, color: '#9CA3AF', marginTop: 1 }}>{tmpl.desc}</Text></View>
          <MaterialCommunityIcons name="arrow-right" size={20} color="#9CA3AF" /></View>
      </TouchableOpacity>))}
      <View style={{ height: 40 }} />
    </ScrollView>
  );

  // ═══════ ASSIGN TAB ═══════
  const renderAssignTab = () => {
    const availableTests = (testData.tests || []).filter(t => t.id);
    return (
      <ScrollView style={{ padding: 16 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}>
        <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#1F2937', marginBottom: 16 }}>Assign Tests to Applicants</Text>
        {availableTests.length === 0 ? <View style={{ alignItems: 'center', padding: 32 }}><MaterialCommunityIcons name="clipboard-text-outline" size={48} color="#D1D5DB" /><Text style={{ fontSize: 16, color: '#6B7280', marginTop: 12 }}>Create a test first</Text>
          <TouchableOpacity style={{ marginTop: 12, backgroundColor: '#0e4e96', paddingHorizontal: 20, paddingVertical: 10, borderRadius: 8 }} onPress={() => setActiveTab('create_test')}><Text style={{ color: '#FFF', fontWeight: '600' }}>Create Test</Text></TouchableOpacity></View>
        : <View>
          <Text style={{ fontSize: 14, fontWeight: '600', color: '#374151', marginBottom: 8 }}>Select a test:</Text>
          {availableTests.slice(0, 10).map((t, i) => (<TouchableOpacity key={t.id || i} style={{ backgroundColor: '#FFF', padding: 12, borderRadius: 8, borderWidth: 1, borderColor: '#E5E7EB', marginBottom: 6 }}
            onPress={() => { const applicantsList = (testData.applicants || []).filter(a => a.id); if (applicantsList.length === 0) { Alert.alert('No Applicants', 'No applicants available'); return; }
              Alert.alert('Assign "' + (t.name || t.title || 'Test') + '"', 'Assign to all ' + applicantsList.length + ' applicants?', [{ text: 'Cancel' }, { text: 'Assign All', onPress: async () => {
                for (const a of applicantsList.slice(0, 20)) { try { await apiRequest('applications/' + a.id, { method: 'PUT', body: { test_assigned: t.id, test_status: 'assigned' } }); } catch {} }
                Alert.alert('Done', 'Test assigned to ' + Math.min(applicantsList.length, 20) + ' applicants'); } },
                { text: 'Select Individual', onPress: () => { setModalType('assign_test'); setShowModal(true); } }]); }}>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <View style={{ width: 36, height: 36, borderRadius: 18, backgroundColor: (t.status || '').toLowerCase() === 'active' || (t.status || '').toLowerCase() === 'assigned' ? '#10B981' : '#0e4e96', justifyContent: 'center', alignItems: 'center', marginRight: 10 }}><MaterialCommunityIcons name="clipboard-check" size={18} color="#FFF" /></View>
              <View style={{ flex: 1 }}><Text style={{ fontSize: 14, fontWeight: '600', color: '#1F2937' }}>{t.name || t.title || 'Test'}</Text>
                <Text style={{ fontSize: 11, color: '#6B7280' }}>{t.type || t.category || 'General'} \u00B7 {t.duration || 60} min \u00B7 {t.status || 'draft'}</Text></View>
              <MaterialCommunityIcons name="account-arrow-right" size={20} color="#0e4e96" /></View>
          </TouchableOpacity>))}
        </View>}
        <View style={{ height: 40 }} />
      </ScrollView>
    );
  };

  const renderFormInput = (label, value, onChangeText, options = {}) => (
    <View style={styles.inputGroup}>
      <Text style={styles.inputLabel}>
        {label} {options.required && <Text style={styles.requiredStar}>*</Text>}
      </Text>
      <TextInput
        style={[
          styles.textInput,
          options.multiline && styles.textArea
        ]}
        value={value}
        onChangeText={onChangeText}
        placeholder={options.placeholder || `Enter ${label.toLowerCase()}`}
        keyboardType={options.keyboardType || 'default'}
        multiline={options.multiline}
        numberOfLines={options.numberOfLines}
      />
    </View>
  );

  const renderPickerInput = (label, value, onValueChange, options, required = false) => (
    <View style={styles.inputGroup}>
      <Text style={styles.inputLabel}>
        {label} {required && <Text style={styles.requiredStar}>*</Text>}
      </Text>
      <View style={styles.pickerContainer}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          {options.map((option) => (
            <TouchableOpacity
              key={option}
              style={[
                styles.pickerOption,
                value === option && styles.pickerOptionSelected
              ]}
              onPress={() => onValueChange(option)}
            >
              <Text style={[
                styles.pickerOptionText,
                value === option && styles.pickerOptionTextSelected
              ]}>
                {option}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
    </View>
  );

  const renderSwitchInput = (label, value, onValueChange) => (
    <View style={styles.switchGroup}>
      <Text style={styles.inputLabel}>{label}</Text>
      <TouchableOpacity
        style={[styles.switch, value && styles.switchActive]}
        onPress={() => onValueChange(!value)}
      >
        <View style={[styles.switchThumb, value && styles.switchThumbActive]} />
      </TouchableOpacity>
    </View>
  );

  const renderAssignTestModal = () => (
    <Modal
      visible={showModal && modalType === 'assign_test'}
      animationType="slide"
      presentationStyle="pageSheet"
    >
      <SafeAreaView style={styles.modalContainer}>
        <View style={styles.modalHeader}>
          <TouchableOpacity onPress={() => {
            setShowModal(false);
            resetNewTestAssignment();
          }}>
            <MaterialCommunityIcons name="close" size={24} color="#64748b" />
          </TouchableOpacity>
          <Text style={styles.modalTitle}>Assign Test</Text>
          <TouchableOpacity onPress={assignTest}>
            <Text style={styles.saveButton}>Assign</Text>
          </TouchableOpacity>
        </View>
        
        <KeyboardAvoidingView 
          style={styles.modalContent}
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        >
          <ScrollView showsVerticalScrollIndicator={false}>
            {renderPickerInput(
              'Test Type',
              newTestAssignment.testType,
              (value) => setNewTestAssignment(prev => ({ ...prev, testType: value })),
              testTypes.slice(1),
              true
            )}

            {renderFormInput(
              'Duration (minutes)',
              newTestAssignment.duration,
              (text) => setNewTestAssignment(prev => ({ ...prev, duration: text })),
              { keyboardType: 'numeric', required: true }
            )}

            {renderFormInput(
              'Deadline',
              newTestAssignment.deadline,
              (text) => setNewTestAssignment(prev => ({ ...prev, deadline: text })),
              { placeholder: 'YYYY-MM-DD' }
            )}

            {renderFormInput(
              'Passing Score (%)',
              newTestAssignment.passingScore,
              (text) => setNewTestAssignment(prev => ({ ...prev, passingScore: text })),
              { keyboardType: 'numeric' }
            )}

            {renderFormInput(
              'Instructions',
              newTestAssignment.instructions,
              (text) => setNewTestAssignment(prev => ({ ...prev, instructions: text })),
              { multiline: true, numberOfLines: 3 }
            )}

            {renderSwitchInput(
              'Allow Retake',
              newTestAssignment.allowRetake,
              (value) => setNewTestAssignment(prev => ({ ...prev, allowRetake: value }))
            )}

            {renderSwitchInput(
              'Randomize Questions',
              newTestAssignment.randomizeQuestions,
              (value) => setNewTestAssignment(prev => ({ ...prev, randomizeQuestions: value }))
            )}

            {selectedApplicants.length > 0 && (
              <View style={styles.selectedApplicantsInfo}>
                <Text style={styles.selectedApplicantsText}>
                  Assigning to {selectedApplicants.length} selected applicant(s)
                </Text>
              </View>
            )}

            {/* Create Custom Test Link */}
            <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0F766E15', borderRadius: 10, padding: 14, marginTop: 16, borderWidth: 1, borderColor: '#0F766E30', borderStyle: 'dashed' }} onPress={() => { setShowModal(false); navigation.navigate('AddNewTestScreen', { jobId, jobTitle, companyLogo, companyName }); }}>
              <MaterialCommunityIcons name="plus-circle" size={20} color="#0F766E" />
              <Text style={{ color: '#0F766E', fontWeight: '700', fontSize: 15, marginLeft: 8 }}>Create Custom Test</Text>
            </TouchableOpacity>
          </ScrollView>
        </KeyboardAvoidingView>
      </SafeAreaView>
    </Modal>
  );

  const renderApplicantDetailsModal = () => (
    <Modal
      visible={showModal && modalType === 'applicant_details'}
      animationType="slide"
      presentationStyle="pageSheet"
    >
      <SafeAreaView style={styles.modalContainer}>
        <View style={styles.modalHeader}>
          <TouchableOpacity onPress={() => setShowModal(false)}>
            <MaterialCommunityIcons name="close" size={24} color="#64748b" />
          </TouchableOpacity>
          <Text style={styles.modalTitle}>Applicant Details</Text>
          <TouchableOpacity>
            <MaterialCommunityIcons name="pencil" size={24} color="#0e4e96" />
          </TouchableOpacity>
        </View>
        
        {selectedApplicant && (
          <ScrollView style={styles.modalContent}>
            <Text style={styles.detailsTitle}>{selectedApplicant.name}</Text>
            <Text style={styles.detailsSubtitle}>{selectedApplicant.position}</Text>
            <Text style={styles.detailsDescription}>{selectedApplicant.email}</Text>
            
            <View style={styles.detailsSection}>
              <Text style={styles.detailsSectionTitle}>Test Information</Text>
              <View style={styles.detailsItem}>
                <Text style={styles.detailsLabel}>Test Type:</Text>
                <Text style={styles.detailsValue}>{selectedApplicant.testType || 'Not Assigned'}</Text>
              </View>
              <View style={styles.detailsItem}>
                <Text style={styles.detailsLabel}>Status:</Text>
                <View style={[
                  styles.statusBadge,
                  { backgroundColor: 
                    selectedApplicant.status === 'Completed' ? '#10b981' : 
                    selectedApplicant.status === 'In Progress' ? '#06b6d4' :
                    selectedApplicant.status === 'Assigned' ? '#8b5cf6' :
                    selectedApplicant.status === 'Failed' ? '#dc2626' :
                    selectedApplicant.status === 'Expired' ? '#f59e0b' : '#64748b'
                  }
                ]}>
                  <Text style={styles.statusText}>{selectedApplicant.status}</Text>
                </View>
              </View>
              <View style={styles.detailsItem}>
                <Text style={styles.detailsLabel}>Score:</Text>
                <Text style={styles.detailsValue}>
                  <Text>{selectedApplicant.testScore ? `${selectedApplicant.testScore}/100` : 'Not Taken'}</Text>
                </Text>
              </View>
              <View style={styles.detailsItem}>
                <Text style={styles.detailsLabel}>Time Spent:</Text>
                <Text style={styles.detailsValue}>
                  <Text>{selectedApplicant.timeSpent ? `${selectedApplicant.timeSpent} min` : 'N/A'}</Text>
                </Text>
              </View>
              <View style={styles.detailsItem}>
                <Text style={styles.detailsLabel}>Attempts:</Text>
                <Text style={styles.detailsValue}>{selectedApplicant.attempts || 0}</Text>
              </View>
              <View style={styles.detailsItem}>
                <Text style={styles.detailsLabel}>Deadline:</Text>
                <Text style={styles.detailsValue}>{selectedApplicant.testDeadline || 'Not Set'}</Text>
              </View>
            </View>

            {selectedApplicant.testScore && (
              <View style={styles.detailsSection}>
                <Text style={styles.detailsSectionTitle}>Performance Analysis</Text>
                <View style={styles.detailsItem}>
                  <Text style={styles.detailsLabel}>Passed:</Text>
                  <Text style={[
                    styles.detailsValue,
                    { color: selectedApplicant.passed ? '#10b981' : '#dc2626' }
                  ]}>
                    <Text>{selectedApplicant.passed ? 'Yes' : 'No'}</Text>
                  </Text>
                </View>
                <View style={styles.detailsItem}>
                  <Text style={styles.detailsLabel}>Feedback:</Text>
                  <Text style={styles.detailsValue}>{selectedApplicant.feedback}</Text>
                </View>
              </View>
            )}

            <View style={styles.actionButtons}>
              {!selectedApplicant.testAssigned && (
                <TouchableOpacity
                  style={[styles.actionButton, { backgroundColor: '#8b5cf6' }]}
                  onPress={() => {
                    setModalType('assign_test');
                    setShowModal(true);
                  }}
                >
                  <Text style={styles.actionButtonText}>Assign Test</Text>
                </TouchableOpacity>
              )}
              {selectedApplicant.testScore && (
                <TouchableOpacity
                  style={[styles.actionButton, { backgroundColor: '#06b6d4' }]}
                  onPress={() => Alert.alert('View Results', 'Detailed test results would be shown here')}
                >
                  <Text style={styles.actionButtonText}>View Results</Text>
                </TouchableOpacity>
              )}
              <TouchableOpacity
                style={[styles.actionButton, { backgroundColor: '#64748b' }]}
                onPress={() => Alert.alert('Send Reminder', 'Test reminder functionality would be implemented here')}
              >
                <Text style={styles.actionButtonText}>Send Reminder</Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        )}
      </SafeAreaView>
    </Modal>
  );

  return (
    <SafeAreaView style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation && navigation.goBack ? navigation.goBack() : null}
        >
          <MaterialCommunityIcons name="arrow-left" size={24} color="#fff" />
        </TouchableOpacity>
        {companyLogo ? (
          <Image source={{ uri: companyLogo || undefined }} style={{ width: 30, height: 30, borderRadius: 15, marginRight: 8 }} />
        ) : (
          <MaterialCommunityIcons name="office-building" size={24} color="#fff" style={{ marginRight: 8 }} />
        )}
        <View style={{ flex: 1 }}>
          <Text style={styles.headerTitle}>Test Applicants</Text>
          {jobTitle ? <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12 }}>{jobTitle}</Text> : null}
        </View>
        <TouchableOpacity style={styles.notificationButton}>
          <MaterialCommunityIcons name="bell" size={24} color="#fff" />
          {testData.notifications.filter(n => !n.read).length > 0 && (
            <View style={styles.notificationBadge}>
              <Text style={styles.notificationBadgeText}>
                {testData.notifications.filter(n => !n.read).length}
              </Text>
            </View>
          )}
        </TouchableOpacity>
      </View>

      {/* Tabs */}
      
      {/* Cross Navigation */}
      <View style={{ backgroundColor: '#FFF', borderBottomWidth: 1, borderBottomColor: '#E5E7EB' }}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{ paddingHorizontal: 12, paddingVertical: 8 }}>
          {jobTitle ? <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#0e4e9615', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.goBack()}>
            <MaterialCommunityIcons name="briefcase" size={14} color="#0e4e96" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#0e4e96', marginLeft: 4 }}>Job Details</Text>
          </TouchableOpacity> : null}
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#3B82F615', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestCandidatesPipelineScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="account-clock" size={14} color="#3B82F6" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#3B82F6', marginLeft: 4 }}>Candidates Pipeline</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#10B98115', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestResultsScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="chart-box" size={14} color="#10B981" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#10B981', marginLeft: 4 }}>Test Results</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#F59E0B15', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestsBankManagementScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="database-cog" size={14} color="#F59E0B" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#F59E0B', marginLeft: 4 }}>Tests Bank</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#0F766E15', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('AddNewTestScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="plus-circle" size={14} color="#0F766E" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#0F766E', marginLeft: 4 }}>Add New Test</Text>
          </TouchableOpacity>
        </ScrollView>
      </View>
<View style={styles.tabsContainer}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          {tabs.map((tab) => (
            <TouchableOpacity
              key={tab.id}
              style={[styles.tab, activeTab === tab.id && styles.activeTab]}
              onPress={() => setActiveTab(tab.id)}
            >
              <MaterialCommunityIcons
                name={tab.icon}
                size={20}
                color={activeTab === tab.id ? '#0e4e96' : '#64748b'}
              />
              <Text style={[styles.tabText, activeTab === tab.id && styles.activeTabText]}>
                {tab.title}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Content */}
      {renderTabContent()}

      {/* Modals */}
      {renderAssignTestModal()}
      {renderApplicantDetailsModal()}


    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f8fafc',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 15,
    backgroundColor: '#4A90E2',
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#fff',
  },
  notificationButton: {
    padding: 8,
    position: 'relative',
  },
  notificationBadge: {
    position: 'absolute',
    top: 4,
    right: 4,
    backgroundColor: '#dc2626',
    borderRadius: 10,
    minWidth: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  notificationBadgeText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  tabsContainer: {
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginHorizontal: 4,
  },
  activeTab: {
    borderBottomWidth: 2,
    borderBottomColor: '#0e4e96',
  },
  tabText: {
    marginLeft: 8,
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
  },
  activeTabText: {
    color: '#0e4e96',
    fontWeight: '600',
  },
  tabContent: {
    flex: 1,
    padding: 20,
  },
  tabContentFull: {
    flex: 1,
    paddingHorizontal: 20,
    paddingTop: 20,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 10,
    fontSize: 16,
    color: '#64748b',
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1e293b',
    marginBottom: 16,
  },
  statsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  statCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    width: (width - 50) / 2,
    borderLeftWidth: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  statContent: {
    flex: 1,
  },
  statHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  statValue: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1e293b',
  },
  trendIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 12,
  },
  trendText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: '600',
    marginLeft: 2,
  },
  statTitle: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
  },
  statSubtitle: {
    fontSize: 12,
    color: '#94a3b8',
    marginTop: 2,
  },
  quickActionsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  quickAction: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    width: (width - 50) / 2,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  quickActionText: {
    marginTop: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1e293b',
    textAlign: 'center',
  },
  additionalMetrics: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  metricItem: {
    width: '48%',
    marginBottom: 16,
  },
  metricLabel: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
    marginBottom: 4,
  },
  metricValue: {
    fontSize: 18,
    color: '#1e293b',
    fontWeight: 'bold',
  },
  searchSection: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  searchContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: '#d1d5db',
    marginRight: 12,
  },
  searchInput: {
    flex: 1,
    marginLeft: 8,
    fontSize: 16,
    color: '#1e293b',
  },
  filterButton: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 12,
    borderWidth: 1,
    borderColor: '#d1d5db',
  },
  bulkActionsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 12,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },
  bulkActionsText: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
  },
  bulkActions: {
    flexDirection: 'row',
  },
  bulkActionButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    marginLeft: 8,
  },
  bulkActionText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '600',
  },
  itemStats: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  itemStatsText: {
    fontSize: 16,
    color: '#64748b',
    fontWeight: '500',
  },
  itemsList: {
    paddingBottom: 20,
  },
  applicantCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  selectedCard: {
    borderWidth: 2,
    borderColor: '#10b981',
  },
  applicantHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  applicantInfo: {
    flex: 1,
  },
  applicantName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1e293b',
    marginBottom: 2,
  },
  applicantPosition: {
    fontSize: 14,
    color: '#64748b',
    marginBottom: 2,
  },
  applicantEmail: {
    fontSize: 12,
    color: '#0e4e96',
    marginBottom: 2,
  },
  applicantExperience: {
    fontSize: 12,
    color: '#94a3b8',
  },
  applicantStatus: {
    alignItems: 'flex-end',
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginBottom: 8,
  },
  statusText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: '600',
  },
  applicantDetails: {
    borderTopWidth: 1,
    borderTopColor: '#e2e8f0',
    paddingTop: 12,
  },
  applicantDetailItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  applicantDetailLabel: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
  },
  applicantDetailValue: {
    fontSize: 14,
    color: '#1e293b',
    fontWeight: '500',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyText: {
    fontSize: 18,
    fontWeight: '600',
    color: '#64748b',
    marginTop: 16,
  },
  emptySubtext: {
    fontSize: 14,
    color: '#94a3b8',
    marginTop: 8,
    textAlign: 'center',
  },
  chartContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  chartTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: 16,
  },
  chartContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    height: 120,
  },
  barChartItem: {
    flex: 1,
    alignItems: 'center',
    marginHorizontal: 2,
  },
  barChartBar: {
    width: '80%',
    height: 80,
    backgroundColor: '#f1f5f9',
    borderRadius: 4,
    justifyContent: 'flex-end',
    marginBottom: 8,
  },
  barChartFill: {
    width: '100%',
    borderRadius: 4,
    minHeight: 4,
  },
  barChartLabel: {
    fontSize: 10,
    color: '#64748b',
    textAlign: 'center',
    marginBottom: 4,
  },
  barChartValue: {
    fontSize: 10,
    color: '#1e293b',
    fontWeight: '600',
    textAlign: 'center',
  },
  modalContainer: {
    flex: 1,
    backgroundColor: '#f8fafc',
  },
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1e293b',
  },
  saveButton: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0e4e96',
  },
  modalContent: {
    flex: 1,
    padding: 20,
  },
  inputGroup: {
    marginBottom: 16,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: '#374151',
    marginBottom: 8,
  },
  requiredStar: {
    color: '#dc2626',
  },
  textInput: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#d1d5db',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 12,
    fontSize: 16,
    color: '#1e293b',
  },
  textArea: {
    height: 80,
    textAlignVertical: 'top',
  },
  pickerContainer: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#d1d5db',
    borderRadius: 8,
    paddingVertical: 8,
  },
  pickerOption: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginHorizontal: 4,
    borderRadius: 6,
  },
  pickerOptionSelected: {
    backgroundColor: '#0e4e96',
  },
  pickerOptionText: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
  },
  pickerOptionTextSelected: {
    color: '#fff',
  },
  switchGroup: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  switch: {
    width: 50,
    height: 30,
    borderRadius: 15,
    backgroundColor: '#d1d5db',
    justifyContent: 'center',
    paddingHorizontal: 2,
  },
  switchActive: {
    backgroundColor: '#0e4e96',
  },
  switchThumb: {
    width: 26,
    height: 26,
    borderRadius: 13,
    backgroundColor: '#fff',
    alignSelf: 'flex-start',
  },
  switchThumbActive: {
    alignSelf: 'flex-end',
  },
  selectedApplicantsInfo: {
    backgroundColor: '#f0f9ff',
    borderRadius: 8,
    padding: 12,
    marginTop: 16,
    borderWidth: 1,
    borderColor: '#0ea5e9',
  },
  selectedApplicantsText: {
    fontSize: 14,
    color: '#0369a1',
    fontWeight: '500',
    textAlign: 'center',
  },
  detailsTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1e293b',
    marginBottom: 4,
  },
  detailsSubtitle: {
    fontSize: 16,
    color: '#64748b',
    marginBottom: 8,
  },
  detailsDescription: {
    fontSize: 14,
    color: '#94a3b8',
    marginBottom: 20,
  },
  detailsSection: {
    marginBottom: 24,
  },
  detailsSectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1e293b',
    marginBottom: 12,
  },
  detailsItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#f1f5f9',
  },
  detailsLabel: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
  },
  detailsValue: {
    fontSize: 14,
    color: '#1e293b',
    fontWeight: '500',
  },
  actionButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 24,
  },
  actionButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
    marginHorizontal: 4,
  },
  actionButtonText: {
    color: '#fff',
    fontWeight: '600',
    fontSize: 14,
  },
});

export default TestApplicantsScreen;
